import { createSelector } from '@reduxjs/toolkit';
import { parseISO } from 'date-fns';
import { selectDates } from 'shared/selectors/jsonQuery';

export const selectDatesValue = createSelector(selectDates, dates => {
  const fromValue = dates?.gte ? parseISO(dates.gte) : null;
  const toValue = dates?.lt ? parseISO(dates.lt) : null;

  return { from: fromValue, to: toValue };
});
